<template>
  <div>
    <NavbarTwo />
    <div class="static-hero">
      <div class="container mw-1356">
        <span class="top-title">ABOUT US</span>
        <h1>{{ c.heading || 'About VivoTv' }}</h1>
        <p>{{ c.subheading || 'Your premium IPTV destination' }}</p>
      </div>
    </div>
    <div class="static-body bg-gondola">
      <div class="container mw-1356" style="max-width:900px">

        <!-- Main body text -->
        <div v-if="c.body" class="about-body" v-html="c.body"></div>

        <!-- Stats row -->
        <div v-if="stats.length" class="about-stats">
          <div v-for="(s, i) in stats" :key="i" class="about-stat">
            <div class="about-stat-value">{{ s.value }}</div>
            <div class="about-stat-label">{{ s.label }}</div>
          </div>
        </div>

        <!-- Feature bullets -->
        <div v-if="features.length" class="about-features">
          <div v-for="(f, i) in features" :key="i" class="about-feature">
            <i class="ti ti-circle-check"></i>
            <span>{{ f }}</span>
          </div>
        </div>
      </div>
    </div>
    <MainFooter />
    <CopyRight />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { useSeo } from "@/composables/useSeo";
import NavbarTwo from "@/components/Layouts/NavbarTwo.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";
import { useContent } from "@/composables/useContent";

export default defineComponent({
  name: "AboutPage",
  components: { NavbarTwo, MainFooter, CopyRight },
  setup() {
    useSeo({
      title: "About Us — Premium IPTV Service",
      description: "goplayTv is a premium IPTV provider delivering 25,000+ live channels, sports, World Cup 2026, and on-demand content in HD/4K to viewers worldwide.",
      url: "/about-us",
      keywords: "about goplayTv, IPTV provider, live sports streaming, premium IPTV service",
    });
    const { content } = useContent("about", { heading: "", subheading: "", body: "", stats: [], features: [] });
    const c = computed(() => content.value);
    const stats = computed(() => Array.isArray(c.value.stats) ? c.value.stats : []);
    const features = computed(() => Array.isArray(c.value.features) ? c.value.features : []);
    return { c, stats, features };
  },
});
</script>

<style scoped>
.static-hero { background: linear-gradient(135deg, #0a0102 0%, #1a0508 100%); padding: 100px 0 60px; border-bottom: 1px solid #2b1e1f; text-align: center; }
.static-hero .top-title { display: inline-block; color: #c90e0e; font-size: 0.8rem; font-weight: 700; letter-spacing: 3px; text-transform: uppercase; margin-bottom: 1rem; }
.static-hero h1 { color: #fff; font-size: clamp(1.8rem, 4vw, 2.6rem); font-weight: 800; margin-bottom: 0.75rem; }
.static-hero p { color: #a0a0a0; }
.static-body { padding: 60px 0 80px; }
.about-body { color: #c0c0c0; line-height: 1.8; font-size: 1rem; margin-bottom: 2.5rem; }
.about-stats { display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 1.25rem; margin-bottom: 2.5rem; }
.about-stat { background: #1a0f10; border: 1px solid #2b1e1f; border-radius: 12px; padding: 1.5rem; text-align: center; }
.about-stat-value { color: #c90e0e; font-size: 2rem; font-weight: 800; line-height: 1; margin-bottom: 0.4rem; }
.about-stat-label { color: #a0a0a0; font-size: 0.82rem; }
.about-features { display: flex; flex-direction: column; gap: 0.75rem; }
.about-feature { display: flex; align-items: flex-start; gap: 0.75rem; color: #c0c0c0; font-size: 0.95rem; }
.about-feature i { color: #c90e0e; font-size: 1.1rem; flex-shrink: 0; margin-top: 1px; }
</style>
